/**
 * Copyright (c) 2025, CYBRA Corp. All rights reserved.
 */

/**
 * The currently configured password composition requirements, as returned by
 * GET /api/users/password-policy.  Used to display the applicable password
 * requirements and provide real-time validation feedback when a password is
 * being created or changed.  A value of 0 means the requirement is not
 * configured.
 */
export class PasswordPolicy {
  minLength = 0;
  minUpper = 0;
  minLower = 0;
  minAlpha = 0;
  minNumeric = 0;
  minSpecial = 0;
  allowWhitespace = false;
}
